<template>
  <div class="page2">
    <img src="../../public/settings/images/page2.jpg" />
    <div class="footer">
      <div>お知らせ</div>
      <div>{{ config.page2_bottom_work }}</div>
    </div>
  </div>
</template>
<script>
import config from '../../public/settings/setting.json'

export default {
  data() {
    return {
      config,
    }
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.page2 {
  background: #fff;
  border-radius: 25px;
  padding: 40px;

  .footer {
    color: #606266;
    div {
      line-height: 30px;
      font-weight: bold;
    }
  }
}
</style>
